// Dependencies
var _ = require('underscore');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

// App
var ListingDetailView = require('app/public-app/apps/listing-detail/view');
var BuildingDetailView = require('app/public-app/apps/building-detail/view');
var errorTplGeneric = require('./common/templates/error.html');
var errorTpl404 = require('./common/templates/404.html');

// Channels
var channel = Radio.channel('global');
var publicChannel = Radio.channel('public');

var Controller = Marionette.Object.extend({
    listingDetail: function(args, querystring, viewType) {
        var listingPromise = publicChannel.request('entities:public:listing', args, querystring);

        listingPromise.then(
            function(listing) {
                var view = new ListingDetailView({
                    model: listing,
                    viewType: viewType,
                    urlArgs: args,
                });

                var mainRegion = channel.request('get:regions').mainRegion;
                mainRegion.show(view);
            },
            function(e) {
                var mainRegion = channel.request('get:regions').mainRegion;
                var errorTpl;

                if (e.errorCode == 404) {
                    errorTpl = errorTpl404;
                } else {
                    errorTpl = errorTplGeneric;
                }

                _.extend(e, {
                    template: errorTpl,
                    className: 'public-error',
                });
                channel.request('show:error', mainRegion, e);
            }
        );
    },
    buildingDetail: function(args, querystring, viewType) {
        var buildingPromise = publicChannel.request('entities:public:building', args, querystring);

        buildingPromise.then(
            function(building) {
                var view = new BuildingDetailView({
                    model: building,
                    viewType: viewType,
                    urlArgs: args,
                });

                var mainRegion = channel.request('get:regions').mainRegion;
                mainRegion.show(view);
            },
            function(e) {
                var mainRegion = channel.request('get:regions').mainRegion;
                var errorTpl;

                if (e.errorCode == 404) {
                    errorTpl = errorTpl404;
                } else {
                    errorTpl = errorTplGeneric;
                }

                _.extend(e, {
                    template: errorTpl,
                    className: 'public-error',
                });
                channel.request('show:error', mainRegion, e);
            }
        );
    },
});

module.exports = Controller;
